import React from 'react';
import { createSvgIcon } from '../IconBase';

export default createSvgIcon(<circle cx="12" cy="12" r="10" />, 'Brightness1');
